import { Dispatch, SetStateAction, useEffect } from 'react'

export default function useWarningChanging(
  hasUnsavedChanges: boolean,
  localStateToUpdate?: Dispatch<SetStateAction<boolean>>,
) {
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (hasUnsavedChanges) {
        const message = 'You have unsaved changed that you will lose.'
        e.preventDefault()
        e.returnValue = message // Standard way to show browser prom
        return message // Some browsers require this for showing the pop-up
      }
    }

    if (localStateToUpdate) localStateToUpdate(hasUnsavedChanges)

    window.addEventListener('beforeunload', handleBeforeUnload)

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [hasUnsavedChanges])
}
